"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SlideAnimationStatus = void 0;
var react_1 = __importStar(require("react"));
var styled_components_1 = __importStar(require("styled-components"));
var b2c_theme_1 = require("../Theme/b2c-theme");
var SlideAnimationStatus;
(function (SlideAnimationStatus) {
    SlideAnimationStatus["CLOSED"] = "CLOSED";
    SlideAnimationStatus["SLIDE_OUT"] = "SLIDE_OUT";
    SlideAnimationStatus["SLIDE_IN"] = "SLIDE_IN";
})(SlideAnimationStatus = exports.SlideAnimationStatus || (exports.SlideAnimationStatus = {}));
var slideInKeyframes = (0, styled_components_1.keyframes)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  from {\n    right: -375px;\n  }\n  to {\n    right: 0;\n  }\n"], ["\n  from {\n    right: -375px;\n  }\n  to {\n    right: 0;\n  }\n"])));
var slideOutKeyframes = (0, styled_components_1.keyframes)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  from {\n    right: 0;\n  }\n  to {\n    right: -375px;\n  }\n"], ["\n  from {\n    right: 0;\n  }\n  to {\n    right: -375px;\n  }\n"])));
var slideInKeyframesMobile = (0, styled_components_1.keyframes)(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  from {\n    right: -100%;\n  }\n  to {\n    right: 0;\n  }\n"], ["\n  from {\n    right: -100%;\n  }\n  to {\n    right: 0;\n  }\n"])));
var slideOutKeyframesMobile = (0, styled_components_1.keyframes)(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n  from {\n    right: 0;\n  }\n  to {\n    right: -100%;\n  }\n"], ["\n  from {\n    right: 0;\n  }\n  to {\n    right: -100%;\n  }\n"])));
var slideAnimation = {
    CLOSED: (0, styled_components_1.css)(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n    animation: none;\n  "], ["\n    animation: none;\n  "]))),
    SLIDE_IN: (0, styled_components_1.css)(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n    animation: ", ";\n    animation-fill-mode: forwards;\n  "], ["\n    animation: ", ";\n    animation-fill-mode: forwards;\n  "])), slideInKeyframes),
    SLIDE_OUT: (0, styled_components_1.css)(templateObject_7 || (templateObject_7 = __makeTemplateObject(["\n    animation: ", ";\n  "], ["\n    animation: ", ";\n  "])), slideOutKeyframes),
};
var slideAnimationMobile = {
    CLOSED: (0, styled_components_1.css)(templateObject_8 || (templateObject_8 = __makeTemplateObject(["\n    animation: none;\n  "], ["\n    animation: none;\n  "]))),
    SLIDE_IN: (0, styled_components_1.css)(templateObject_9 || (templateObject_9 = __makeTemplateObject(["\n    animation: ", ";\n    animation-fill-mode: forwards;\n  "], ["\n    animation: ", ";\n    animation-fill-mode: forwards;\n  "])), slideInKeyframesMobile),
    SLIDE_OUT: (0, styled_components_1.css)(templateObject_10 || (templateObject_10 = __makeTemplateObject(["\n    animation: ", ";\n  "], ["\n    animation: ", ";\n  "])), slideOutKeyframesMobile),
};
var SidePanelContainer = styled_components_1.default.div(templateObject_12 || (templateObject_12 = __makeTemplateObject(["\n  display: block;\n  position: fixed;\n  z-index: 30;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  width: 100vw;\n  background: ", ";\n  pointer-events: none;\n\n  ", "\n"], ["\n  display: block;\n  position: fixed;\n  z-index: 30;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  width: 100vw;\n  background: ", ";\n  pointer-events: none;\n\n  ", "\n"])), function () { return "rgba(".concat(b2c_theme_1.colors.overlayColorRGBA, ", 0)"); }, function (_a) {
    var panelStatus = _a.panelStatus;
    return panelStatus &&
        panelStatus === SlideAnimationStatus.SLIDE_IN && (0, styled_components_1.css)(templateObject_11 || (templateObject_11 = __makeTemplateObject(["\n      background: ", ";\n      pointer-events: all;\n    "], ["\n      background: ", ";\n      pointer-events: all;\n    "])), function () { return "rgba(".concat(b2c_theme_1.colors.overlayColorRGBA, ", 0.6)"); });
});
var SidePanelWrapper = styled_components_1.default.div(templateObject_13 || (templateObject_13 = __makeTemplateObject(["\n  position: absolute;\n  width: 100%;\n  background: white;\n  height: 100%;\n  top: 0;\n  bottom: 0;\n  right: -100%;\n  overflow-y: scroll;\n  ", ";\n  animation-duration: ", ";\n  animation-timing-function: linear;\n\n  @media (min-width: 480px) {\n    width: 90%;\n    max-width: 375px;\n    right: -375px;\n    ", ";\n    animation-duration: ", ";\n    animation-timing-function: linear;\n  }\n"], ["\n  position: absolute;\n  width: 100%;\n  background: white;\n  height: 100%;\n  top: 0;\n  bottom: 0;\n  right: -100%;\n  overflow-y: scroll;\n  ", ";\n  animation-duration: ", ";\n  animation-timing-function: linear;\n\n  @media (min-width: 480px) {\n    width: 90%;\n    max-width: 375px;\n    right: -375px;\n    ", ";\n    animation-duration: ", ";\n    animation-timing-function: linear;\n  }\n"])), function (_a) {
    var panelStatus = _a.panelStatus;
    return slideAnimationMobile[panelStatus];
}, function (_a) {
    var animationDuration = _a.animationDuration;
    return animationDuration;
}, function (_a) {
    var panelStatus = _a.panelStatus;
    return slideAnimation[panelStatus];
}, function (_a) {
    var animationDuration = _a.animationDuration;
    return animationDuration;
});
var SidePanelContent = styled_components_1.default.div(templateObject_14 || (templateObject_14 = __makeTemplateObject(["\n  position: fixed;\n  height: 100%;\n"], ["\n  position: fixed;\n  height: 100%;\n"])));
var SidePanel = function (props) {
    var _a = props.animationDuration, animationDuration = _a === void 0 ? '0.3s' : _a, children = props.children, _b = props.closedClassName, closedClassName = _b === void 0 ? '' : _b, onClose = props.onClose, onStatusChangeEnd = props.onStatusChangeEnd, _c = props.openClassName, openClassName = _c === void 0 ? '' : _c, panelStatus = props.panelStatus, rest = __rest(props, ["animationDuration", "children", "closedClassName", "onClose", "onStatusChangeEnd", "openClassName", "panelStatus"]);
    var wrapperRef = (0, react_1.useRef)(null);
    var _d = (0, react_1.useState)(panelStatus === SlideAnimationStatus.SLIDE_IN
        ? openClassName
        : closedClassName), statusClassName = _d[0], setStatusClassName = _d[1];
    (0, react_1.useEffect)(function () {
        var listener = function (event) {
            if (event.type === 'animationend' ||
                event.type === 'webkitAnimationEnd' ||
                event.type === 'MSAnimationEnd') {
                panelStatus === SlideAnimationStatus.SLIDE_IN
                    ? setStatusClassName(openClassName)
                    : setStatusClassName(closedClassName);
                if (onStatusChangeEnd) {
                    onStatusChangeEnd(panelStatus);
                }
            }
        };
        var element = wrapperRef.current;
        element === null || element === void 0 ? void 0 : element.addEventListener('animationend', listener);
        element === null || element === void 0 ? void 0 : element.addEventListener('webkitAnimationEnd', listener);
        element === null || element === void 0 ? void 0 : element.addEventListener('MSAnimationEnd', listener);
        return function () {
            element === null || element === void 0 ? void 0 : element.removeEventListener('animationend', listener);
            element === null || element === void 0 ? void 0 : element.removeEventListener('webkitAnimationEnd', listener);
            element === null || element === void 0 ? void 0 : element.removeEventListener('MSAnimationEnd', listener);
        };
    }, [panelStatus]);
    var clickOutsideToClose = function (event) {
        var _a;
        if (event.target instanceof HTMLElement &&
            ((_a = event.target.dataset) === null || _a === void 0 ? void 0 : _a.isOverlay) &&
            panelStatus === SlideAnimationStatus.SLIDE_IN &&
            onClose) {
            onClose();
        }
    };
    return (react_1.default.createElement(SidePanelContainer, __assign({ "data-is-overlay": true, "data-testid": "side-panel-container", onClick: clickOutsideToClose, panelStatus: panelStatus }, rest),
        react_1.default.createElement(SidePanelWrapper, { animationDuration: animationDuration, className: "".concat(statusClassName), "data-testid": "side-panel-wrapper", panelStatus: panelStatus, ref: wrapperRef },
            react_1.default.createElement(SidePanelContent, { "data-testid": "side-panel-content" }, children))));
};
exports.default = SidePanel;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7, templateObject_8, templateObject_9, templateObject_10, templateObject_11, templateObject_12, templateObject_13, templateObject_14;
//# sourceMappingURL=SidePanel.js.map


//////////////////
// WEBPACK FOOTER
// /home/jenkins/agent/workspace/eb-apps_b2c-site_b2c-site_master/node_modules/@urbanmassage/component-library/lib/SidePanel/SidePanel.js
// module id = 1454
// module chunks = 2 5 16 17 18 19 20